import React, { ReactNode } from 'react';
import Box, { BoxProps } from 'ui-box';
import { majorScale } from '.';
import { Heading } from './Heading';

export interface ISectionProps extends BoxProps<any> {
  title: ReactNode;
  actions?: ReactNode;
}

export const Section: React.FC<ISectionProps> = ({
  title,
  actions,
  children,
  ...props
}) => (
  <Box marginBottom={majorScale(5)} {...props}>
    <Box
      display="flex"
      alignItems="baseline"
      justifyContent="space-between"
      className="border-bottom"
      minHeight={42}
      paddingBottom={majorScale(1)}
      marginBottom={majorScale(2)}
    >
      {typeof title === 'string' ? (
        <Heading size={400}>{title}</Heading>
      ) : (
        title
      )}
      {actions}
    </Box>
    {children}
  </Box>
);
